import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
// model
import { User, Userdata } from 'src/app/shared/interfaces/user.interface';
import { clearSetting, updateChain, updateCountry } from 'src/app/states/actions/setting.action';
//store
import { addUser, clearUser } from 'src/app/states/actions/user.actions';
import { selectUserdata } from 'src/app/states/selectors/user.selector';

@Injectable({ providedIn: 'root' })
export class AuthService {
  isLoggedIn: boolean;
  userToken: string | null;
  userData: Userdata | null;
  public backUrl$ = new BehaviorSubject<string | null>(null);

  constructor(private router: Router, private location: Location, private store: Store, private cookieService: CookieService) {
    this.isLoggedIn = false;
    this.userToken = null;
    this.userData = null;
    this.store.select(selectUserdata).subscribe((value: User) => {
      if (value) {
        this.isLoggedIn = value.isLoggedIn;
        this.userToken = value.token;
        this.userData = value.data;
      }
    });
  }

  public isAuthenticated(): boolean {
    return this.isLoggedIn;
  }

  public getAuthorizationToken(): string | null {
    if (!this.isLoggedIn || !this.userToken) return null;
    return this.userToken;
  }
  public getToken(): string | null {
    return this.cookieService.get('X-Auth-Token');
  }
  public getRefreshToken(): string | null {
    return this.cookieService.get('X-Auth-RefreshToken');
  }
  public setAuthorizationToken(token: string) {
    this.isLoggedIn = true;
    this.userToken = token;
  }

  public login(data: User, refreshToken: string) {
    this.isLoggedIn = data.isLoggedIn;
    this.setStateSettingChain(data?.data?.chain_id, data?.data?.chain_name);
    this.setStateSettingCountry(data?.data?.country_id, data?.data?.country_name);
    this.store.dispatch(addUser({ payload: data }));
    if (data.token) {
      this.userToken = data.token;
      // this.cookieService.set('X-Auth-Token', data.token, 7, '/');
      if (data?.token) this.cookieService.set('X-Auth-Token', data?.token, 30, '/', undefined, true, 'Lax');
      if (refreshToken) this.cookieService.set('X-Auth-RefreshToken', refreshToken, 30, '/', undefined, true, 'Lax');
    }
    if (this.backUrl$.value) {
      this.location.replaceState(this.backUrl$.value);
      this.router.navigate([this.backUrl$.value]);
      this.backUrl$.next(null);
      return;
    }
    this.location.replaceState('/home');
    this.router.navigateByUrl('/home').then((r) => r);
  }

  //Set state setting chain
  private setStateSettingChain(chain_id?: string, chain_name?: string) {
    const data: { chain_id: string; chain_name: string } = {
      chain_id: !chain_id ? '' : chain_id,
      chain_name: !chain_name ? '' : chain_name,
    };
    this.store.dispatch(updateChain(data));
  }

  //Set state setting country
  private setStateSettingCountry(country_id?: string, country_name?: string) {
    const countryData: { country_id: string; country_name: string } = {
      country_id: !country_id ? '' : country_id,
      country_name: !country_name ? '' : country_name,
    };
    this.store.dispatch(updateCountry(countryData));
  }

  public logout() {
    this.isLoggedIn = false;
    this.userToken = null;
    this.store.dispatch(clearUser());
    this.store.dispatch(clearSetting());
    this.cookieService.delete('X-Auth-Token');
    this.cookieService.delete('X-Auth-RefreshToken');
    this.location.replaceState('/');
    this.router.navigateByUrl('/auth/login');
  }

  public checkLogin() {
    if (this.isLoggedIn) return this.router.navigateByUrl('/home');
    return false;
  }
}
